import React, {Component} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import ServicesList from "./views/ServicesList";
import ServicePanel from "./panels/ServicePanel";
import { List} from "immutable";

class ServicesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      hasSelection: false,
      selectedId: null
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    return (
      <div className="ServicesPage SecurePage">
        <AppSidebar />
        <PageHeader title="Services" />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Start Service"
              active={this.state.hasSelection}
              onClick={this.handleStartService.bind(this)}
              />
            <ActionButton
              label="Stop Service"
              active={this.state.hasSelection}
              onClick={this.handleStopService.bind(this)}
              />
            <ActionButton
              label="Run Service"
              active={this.state.hasSelection}
              onClick={this.handleRunService.bind(this)}
              />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    switch(page) {
      default:
        return <ServicesList
                  key="ServicesList"
                  selectedId={this.state.selectedId} 
                  onSelectionChange={this.handleSetSelection}
                  />
    }
  }

  renderPanels(page) {
    if (!this.state.hasSelection) return null;
    return this.buildPanels(List([ServicePanel]));
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case ServicePanel:
        return <ServicePanel key="service-panel" serviceId={this.state.selectedId} />
      default:
        return null;      
    }
  }

  handleSetSelection(item) {
    this.setState({
      hasSelection: true,
      selectedId: item.get("serviceId")
    });
  }

  handleStartService() {
    this.props.requestStartService(this.state.selectedId);
  }

  handleStopService() {
    this.props.requestStopService(this.state.selectedId);
  }

  handleRunService() {
    this.props.requestRunService(this.state.selectedId);
  }

}

export default ServicesPage;